import * as React from 'react'
// libs
import { motion } from 'motion/react'
// styles
import './styles.css'
// assets
import Resume from '../../../../../assets/imgs/recruting/resume.png'
import Arrow1 from '../../../../../assets/imgs/recruting/arrow-1.png'
import Arrow2 from '../../../../../assets/imgs/recruting/arrow-2.png'
import Matching from '../../../../../assets/imgs/recruting/matching.png'
import MailIcon from '../../../../../assets/imgs/recruting/mail-icon.png'
import OpenedPosition from '../../../../../assets/imgs/recruting/opened-position.png'

const float = (dx = 0, dy = 6, dur = 6) => ({
  animate: { x: [0, dx, 0, -dx, 0], y: [0, -dy, 0, dy, 0] },
  transition: {
    duration: dur,
    repeat: Infinity,
    repeatType: 'loop',
    ease: 'easeInOut',
  },
})

const Automatically = () => {
  return (
    <div className='recruiting-automatically-animation'>
      <motion.img
        className='recruiting-automatically-animation-layer recruiting-automatically-animation-opened'
        src={OpenedPosition}
        {...float(2, 5, 7)}
      />

      <motion.img
        className='recruiting-automatically-animation-layer recruiting-automatically-animation-resume'
        src={Resume}
        {...float(0, 4, 8)}
      />

      <motion.img
        className='recruiting-automatically-animation-layer recruiting-automatically-animation-matching'
        src={Matching}
        {...float(3, 3, 7.5)}
      />

      <motion.img
        className='recruiting-automatically-animation-layer recruiting-automatically-animation-mail'
        src={MailIcon}
        animate={{ scale: [1, 1.06, 1] }}
        transition={{
          duration: 1.2,
          ease: 'easeInOut',
          repeat: Infinity,
          repeatDelay: 2,
        }}
      />

      <motion.img
        className='recruiting-automatically-animation-layer recruiting-automatically-animation-arrow1'
        src={Arrow1}
        animate={{ rotate: [0, -3, 0, 3, 0] }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        style={{ originX: 0.2, originY: 0.7 }}
      />

      <motion.img
        className='recruiting-automatically-animation-layer recruiting-automatically-animation-arrow2'
        src={Arrow2}
        animate={{ rotate: [0, 3, 0, -3, 0] }}
        transition={{
          duration: 5.3,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        style={{ originX: 0.7, originY: 0.4 }}
      />
    </div>
  )
}

export default Automatically
